import { useEffect } from "react";
import { SITE_URL } from "../../data/services";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, keywords, path = "/", image, jsonLd }) => {
  useEffect(() => {
    const url = SITE_URL + path;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setLink("canonical", url);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", "Fixedrone");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    let ld = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "seo-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    }
  }, [title, description, keywords, path, image, jsonLd]);

  return null;
};

export const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Fixedrone",
  description: "Services de drone professionnels : inspection, thermographie, cartographie, topographie et agriculture de précision au Luxembourg et régions frontalières.",
  image: "https://customer-assets-lqy194kg.emergentagent.net/job_drone-energy/artifacts/vhxvvlkz_image.png",
  url: SITE_URL,
  telephone: "+33749850244",
  email: "info@fixedrone.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "6D, Route de Trèves",
    addressLocality: "Senningerberg",
    postalCode: "L-2633",
    addressCountry: "LU",
  },
  areaServed: ["Luxembourg", "France", "Belgique", "Allemagne"],
  openingHours: "Mo-Fr 09:00-17:00",
};
